{
	"common": {
		"cancel": "Cancel",
		"undo": "Undo",
		"opensNewTab": "(opens in a new tab)"
	},
	"app": {
		"name": "Scope"
	},
	"nav": {
		"sections": "Sections",
		"questionSections": "Question sections",
		"backToPlatform": "Back to kiss.cat",
		"account": "Account",
		"accounts": "Accounts",
		"addAccount": "Add account",
		"profile": "Profile",
		"signOut": "Sign out",
		"allScopes": "All scopes",
		"openMenu": "Open menu",
		"closeMenu": "Close menu",
		"skipToContent": "Skip to content",
		"home": "KISS.cat home",
		"primary": "Primary",
		"expand": "Expand sidebar",
		"collapse": "Collapse sidebar"
	},
	"scopes": {
		"title": "Scopes",
		"new": "New scope",
		"unnamed": "New scope",
		"resume": "Resume",
		"open": "Open",
		"archive": "Archive",
		"unarchive": "Unarchive",
		"restore": "Restore",
		"deleteAction": "Delete…",
		"rowMenu": "More actions for {{title}}",
		"delete": {
			"title": "Delete this scope?",
			"body": "\"{{title}}\" and its questions, review and docs will be removed. This cannot be undone.",
			"confirm": "Delete scope"
		},
		"edited": "Edited {{when}}",
		"archivedWhen": "Archived",
		"stageDone": "Done",
		"emptyTitle": "No scopes yet",
		"emptyFilteredTitle": "No scopes match this filter",
		"emptyDescription": "Turn a rough idea into a documented plan and a ready-to-build backlog.",
		"showAll": "Show all scopes",
		"errorTitle": "Couldn't load your scopes",
		"errorDescription": "Something went wrong loading your scopes. Try again.",
		"retry": "Try again",
		"archivedToast": "Scope archived",
		"archivedEmptyTitle": "No archived scopes",
		"archivedEmptyDescription": "Scopes you archive from the list show up here.",
		"disabled": "Scope is not available yet.",
		"disabledHint": "Ask your workspace admin to turn it on, or head back to kiss.cat.",
		"shape": {
			"NEW_APP": "New app",
			"FEATURE": "Feature",
			"INTEGRATION": "Integration",
			"MIGRATION": "Migration",
			"OTHER": "Other"
		},
		"status": {
			"DRAFT": "Draft",
			"IN_PROGRESS": "In progress",
			"SETTLED": "Settled",
			"GENERATED": "Board created"
		},
		"filters": {
			"label": "Filter",
			"all": "All",
			"inProgress": "In progress",
			"settled": "Settled",
			"drafts": "Drafts",
			"archived": "Archived"
		}
	},
	"intake": {
		"opener": "Let's scope something. In a sentence or two, what are you building and who's it for? Talk it out or type.",
		"stepper": "Scope stages",
		"stagePosition": "{{current}}/{{total}}",
		"thread": {
			"label": "Conversation"
		},
		"step": {
			"current": "(current step)",
			"done": "(completed)",
			"locked": "(locked, finish the earlier stages first)"
		},
		"locked": {
			"hint": "Unlocks after {{stage}}"
		},
		"stageSheet": {
			"title": "Stages"
		},
		"why": {
			"dismiss": "Got it"
		},
		"archived": "Archived",
		"loading": "Loading scope…",
		"thinking": "Thinking…",
		"errorTitle": "Couldn't load this scope",
		"errorBody": "Something went wrong loading this scope. Try refreshing the page.",
		"notFound": "This scope doesn't exist or was deleted.",
		"backToScopes": "Back to scopes",
		"steps": {
			"describe": "Describe",
			"questions": "Questions",
			"review": "Review",
			"documents": "Documents",
			"backlog": "Backlog"
		},
		"cta": {
			"lead": "Describe what you're building. A couple of lines is enough.",
			"generating": "Generating…",
			"needBrief": "Answer a few questions so the brief is ready",
			"soon": "Coming next",
			"handToAgent": "Hand off to your agent",
			"toQuestions": "Go to Questions"
		},
		"composer": {
			"placeholder": "Reply, or add anything the brief is missing…",
			"label": "Message",
			"dictate": "Dictate",
			"stopDictation": "Stop dictation",
			"send": "Send",
			"sending": "Sending…"
		},
		"notSent": "Not sent",
		"retry": "Retry",
		"reply": {
			"fallback": "Got it. I've updated the brief."
		},
		"error": {
			"title": "That message didn't send",
			"body": "Check your connection and try again."
		},
		"brief": {
			"title": "Brief",
			"edit": "Edit {{field}}: {{value}}",
			"name": "Name",
			"namePlaceholder": "Name this scope",
			"idea": "Idea",
			"ideaPlaceholder": "Add the idea in a line or two",
			"audience": "Who it's for",
			"audiencePlaceholder": "Who is this for?",
			"platform": "Platform",
			"platformPlaceholder": "Mobile, desktop, or both?",
			"shape": "Shape",
			"shapeEmpty": "Choose a shape",
			"whyNow": "Why now",
			"whyNowPlaceholder": "What makes this worth doing now?",
			"offLimits": "Off-limits",
			"offLimitsPlaceholder": "What's off the table for v1?",
			"linkPlaceholder": "Paste a link",
			"links": "Links"
		},
		"stageMenu": "Stage: {{stage}}. Open stage menu"
	},
	"links": {
		"heading": "Links",
		"placeholder": "Paste a URL, like a repo, doc, or design",
		"invalid": "That doesn't look like a link.",
		"add": "Add",
		"open": "Open in new tab",
		"remove": "Remove",
		"empty": "No links yet.",
		"pr": {
			"open": "Open",
			"merged": "Merged",
			"closed": "Closed",
			"draft": "Draft"
		}
	},
	"questions": {
		"progressShort": "{{answered}}/{{total}}",
		"emptySection": "No questions in this section.",
		"cta": {
			"acceptAll": "Accept all",
			"acceptAllTitle": "Accept every suggestion",
			"runReview": "Run review",
			"runReviewHint": "Answer every question first ({{count}} still open)",
			"generateDocs": "Generate docs"
		},
		"rail": {
			"foundationalOnly": "Foundational only",
			"count": "{{answered}}/{{total}}",
			"sections": "Sections"
		},
		"card": {
			"foundational": "Foundational",
			"answered": "Answered",
			"accept": "Accept suggestion",
			"acceptFor": "Accept suggestion for {{ref}}",
			"answerMyself": "Answer myself",
			"answerMyselfFor": "Answer {{ref}} myself",
			"saveAnswer": "Save answer",
			"cancel": "Cancel",
			"edit": "Edit",
			"editFor": "Edit answer for {{ref}}",
			"answerLabel": "Your answer",
			"answerPlaceholder": "Type your answer…",
			"lowConfidence": "Low confidence",
			"source": {
				"decidedByAgent": "Decided by {{agent}}",
				"answeredByAgent": "Answered by {{agent}}",
				"accepted": "You accepted the suggestion",
				"yourDecision": "Your decision",
				"yourAnswer": "Your answer"
			}
		},
		"emptyFiltered": "No foundational questions to show."
	},
	"review": {
		"running": "Running review…",
		"cta": {
			"rerun": "Re-run review",
			"rerunAnyway": "Re-run review anyway",
			"generateDocs": "Generate docs",
			"openDocs": "Open documents",
			"regenerateDocs": "Regenerate docs…",
			"archivedHint": "This scope is archived"
		},
		"banner": {
			"toSettle_one": "Review found {{count}} thing to settle",
			"toSettle_other": "Review found {{count}} things to settle",
			"summaryFallback": "I re-read your answers, checked them against each other, and flagged what needs a second look.",
			"answerRemaining": "Answer the remaining questions",
			"answerRemainingBody_one": "Answer the {{count}} open question back in Questions, then re-run review to settle and unlock docs.",
			"answerRemainingBody_other": "Answer the {{count}} open questions back in Questions, then re-run review to settle and unlock docs.",
			"dirtyTitle": "Answers changed since the last review",
			"dirtyBody": "Re-run review to confirm the edits raised nothing new, then docs unlock.",
			"resolvedTitle": "All resolved",
			"resolvedBody": "Re-run review to settle and unlock docs."
		},
		"lock": {
			"conflicts_one": "{{count}} conflict",
			"conflicts_other": "{{count}} conflicts",
			"followUps_one": "{{count}} new question",
			"followUps_other": "{{count}} new questions",
			"open_one": "{{count}} to answer",
			"open_other": "{{count}} to answer"
		},
		"stats": {
			"conflicts_one": "{{count}} conflict",
			"conflicts_other": "{{count}} conflicts",
			"openQuestions_one": "{{count}} open question",
			"openQuestions_other": "{{count}} open questions",
			"decisions_one": "{{count}} decision",
			"decisions_other": "{{count}} decisions"
		},
		"conflicts": {
			"heading": "Conflicts to resolve"
		},
		"conflict": {
			"tag": "Conflict",
			"noAnswer": "No answer yet.",
			"noFix": "No single fix suggested: edit one of the answers, then resolve.",
			"rewrites": "Rewrites {{ref}}",
			"accept": "Accept reconciliation",
			"acceptFor": "Accept reconciliation for {{refs}}",
			"editMenu": "Edit an answer",
			"edit": "Edit {{ref}}",
			"editLabel": "Edit {{ref}}",
			"edited": "Edited",
			"save": "Save",
			"cancel": "Cancel",
			"resolve": "Resolve",
			"markResolved": "Mark resolved",
			"resolveFor": "Resolve conflict for {{refs}}"
		},
		"followUps": {
			"heading": "New questions your answers created",
			"new": "New",
			"spawnedFrom": "Spawned from your answer to {{ref}}"
		},
		"empty": {
			"answerFirstTitle": "No review pass yet",
			"answerFirstBody": "Answer the remaining questions first, then a review pass cross-checks them and unlocks the docs.",
			"toQuestions": "Back to Questions",
			"runTitle": "No review pass yet",
			"runBody": "Run the review to cross-check your answers for contradictions before the docs are generated."
		},
		"settled": {
			"title": "Everything's settled",
			"subtitle": "No conflicts left, and every question is answered.",
			"copy": "Reviewed clean. Generate the build docs when you're ready, or step back to tweak any answer."
		},
		"settledHero": {
			"title": "This scope is settled",
			"body": "Reviewed on {{on}}. Reconciled <strong>{{conflicts}}</strong> and answered <strong>{{followUps}}</strong>. The spec is locked and the build docs are ready to hand to your agent.",
			"conflicts_one": "{{count}} conflict",
			"conflicts_other": "{{count}} conflicts",
			"follow_one": "{{count}} follow-up",
			"follow_other": "{{count}} follow-ups",
			"rounds_one": "round",
			"rounds_other": "rounds",
			"reconciledStat": "reconciled",
			"followStat_one": "follow-up",
			"followStat_other": "follow-ups"
		},
		"trail": {
			"view": "View decision trail"
		}
	},
	"documents": {
		"generating": "Generating docs…",
		"meta_one": "Generated from {{count}} decision",
		"meta_other": "Generated from {{count}} decisions",
		"cta": {
			"generateBacklog": "Generate backlog",
			"openBacklog": "Open backlog",
			"regenerateBacklog": "Regenerate backlog…",
			"archivedHint": "This scope is archived"
		},
		"tree": {
			"label": "Documents",
			"buildDocs": "Build docs",
			"archive": "Decision record",
			"noBuildDocs": "No build docs yet. Generate them from Review."
		},
		"archive": {
			"confidence": "{{level}} confidence"
		},
		"record": {
			"history": "Review history",
			"reconciledHere": "Reconciled here:"
		}
	},
	"decisionTrail": {
		"you": "You",
		"agentFallback": "Your agent",
		"noAnswer": "No answer recorded.",
		"raisedFrom": "raised from {{ref}}",
		"reconciledWhen": "Reconciled {{when}}",
		"round": "Round {{number}}",
		"roundCounts": "{{conflicts}} conflicts flagged, {{questions}} raised",
		"status": {
			"answered": "Answered",
			"reconciled": "Reconciled",
			"followUp": "Follow-up"
		}
	},
	"regenerate": {
		"cancel": "Cancel",
		"docs": {
			"title": "Regenerate the documents?",
			"body": "This hands the docs back to your agent, and its write replaces the current build docs for this scope. Tickets already created on the board are not affected. Only the generated docs are replaced.",
			"confirm": "Regenerate docs"
		},
		"backlog": {
			"title": "Regenerate the backlog?",
			"body": "This hands the backlog back to your agent, and its write replaces the current proposal. Tickets you've already created on the board are not affected. Only this proposal is replaced.",
			"confirm": "Regenerate backlog"
		}
	},
	"backlog": {
		"generating": "Generating backlog…",
		"empty": {
			"title": "No backlog yet",
			"description": "Propose epics and one-PR-sized tickets from your settled docs. Edit anything before you create it on the board.",
			"generate": "Generate backlog"
		},
		"cta": {
			"back": "Back to Documents",
			"lead": "{{epics}} · {{tickets}} · in build order",
			"create": "Create the tickets",
			"archivedHint": "This scope is archived"
		},
		"count": {
			"epics_one": "{{count}} epic",
			"epics_other": "{{count}} epics",
			"tickets_one": "{{count}} ticket",
			"tickets_other": "{{count}} tickets"
		},
		"createStep": {
			"title": "Create the tickets",
			"sub": "Turn the proposal into real epics and tickets on a board. {{epics}} and {{tickets}} land in the board backlog; empty epics are skipped.",
			"boardLabel": "Board",
			"newBoard": "New board…",
			"namePlaceholder": "Board name",
			"nameLabel": "New board name",
			"idempotent": "Re-running is safe. Tickets already on the board are kept as they are, never duplicated.",
			"handoff": "Hand off to your agent instead",
			"create": "Create the tickets",
			"creating": "Creating…"
		},
		"created": {
			"title": "{{tickets}} on your board",
			"titleKey": "{{tickets}} in {{key}}'s backlog",
			"detail": "Created {{epics}} and {{tickets}} from this scope.",
			"addedDetail": "Added {{added}} to the board ({{already}} were already there).",
			"openBoard": "Open board",
			"rerun_one": "Create {{count}} new ticket",
			"rerun_other": "Create {{count}} new tickets",
			"creating": "Creating…"
		},
		"intro_one": "Proposed from your {{count}} decision. <edit>Edit anything</edit> (rename epics, open a ticket to edit its description or remove it, add your own). Nothing reaches a board until you create it.",
		"intro_other": "Proposed from your {{count}} decisions. <edit>Edit anything</edit> (rename epics, open a ticket to edit its description or remove it, add your own). Nothing reaches a board until you create it.",
		"proposedBy": "Proposed by {{agent}}",
		"epic": {
			"count_one": "{{count}} ticket",
			"count_other": "{{count}} tickets",
			"rename": "Rename epic",
			"removeEpic": "Remove epic",
			"nameLabel": "Epic name",
			"saveName": "Save",
			"cancelName": "Cancel",
			"empty": "No tickets yet. Add one below, or remove the epic. Empty epics are skipped when you create the board.",
			"confirmRemove": "Remove this epic and its tickets from the proposal?",
			"confirmRemoveYes": "Remove",
			"confirmRemoveNo": "Keep",
			"addTicket": "Add a ticket",
			"addPlaceholder": "Ticket title…",
			"addLabel": "New ticket title",
			"add": "Add",
			"cancelAdd": "Cancel"
		},
		"ticket": {
			"description": "Description",
			"descriptionLabel": "Ticket description",
			"descriptionPlaceholder": "Describe the WHAT…",
			"descriptionEmpty": "No description yet.",
			"builtOn": "Built on",
			"onBoard": "On the board",
			"createdNote": "On the board. Edits here won't change the task.",
			"createdNoteLink": "On the board as <a>{{ref}}<ext></ext></a>. Edits here won't change the task.",
			"edit": "Edit",
			"editRow": "Edit {{ref}}",
			"save": "Save",
			"cancel": "Cancel",
			"remove": "Remove ticket",
			"removed": "Ticket removed",
			"confirmRemove": "Remove this ticket?",
			"confirmRemoveCreated": "Remove from the proposal? The board task stays.",
			"confirmRemoveYes": "Remove",
			"confirmRemoveNo": "Keep"
		}
	},
	"voice": {
		"starting": "Starting",
		"capped": "Reached the dictation time limit."
	},
	"handoff": {
		"title": {
			"questions": "Draft the questions with your agent",
			"review": "Run the review with your agent",
			"documents": "Write the docs with your agent",
			"backlog": "Draft the backlog with your agent"
		},
		"workingTitle": "{{agent}} is working",
		"anAgent": "Your agent",
		"log": {
			"label": "Agent progress",
			"live": "Live",
			"working": "Working this scope",
			"via": "{{agent}} via {{person}}",
			"anAgent": "Your agent",
			"countQuestions_one": "<b>{{count}}</b> question",
			"countQuestions_other": "<b>{{count}}</b> questions",
			"countSections_one": "across <b>{{count}}</b> section",
			"countSections_other": "across <b>{{count}}</b> sections",
			"countSuffix": "so far"
		},
		"step": {
			"questions": {
				"waiting": "Waiting for your agent to draft the questions",
				"action": "draft the questions",
				"workingSub": "{{agent}} is drafting your questions. Close this any time and check back later; it keeps going."
			},
			"review": {
				"waiting": "Waiting for your agent to run the review",
				"action": "run the review",
				"workingSub": "{{agent}} is running the review. Close this any time and check back later; it keeps going."
			},
			"documents": {
				"waiting": "Waiting for your agent to write the docs",
				"action": "write the docs",
				"workingSub": "{{agent}} is writing the docs. Close this any time and check back later; it keeps going."
			},
			"backlog": {
				"waiting": "Waiting for your agent to draft the backlog",
				"action": "draft the backlog",
				"workingSub": "{{agent}} is drafting the backlog. Close this any time and check back later; it keeps going."
			}
		},
		"working": {
			"questions": "Drafting the questions…",
			"review": "Running the review…",
			"documents": "Writing the docs…",
			"backlog": "Drafting the backlog…"
		},
		"landed": {
			"questions": "Questions landed",
			"review": "Review landed",
			"documents": "Docs landed",
			"backlog": "Backlog landed"
		},
		"check": {
			"connected": "{{name}} connected",
			"connectedMany": "{{count}} agents connected",
			"anAgent": "Your agent",
			"notConnected": "Connect an agent first",
			"notConnectedDesc": "KISS Scope works with your own coding agent. Connect one over MCP (about a minute) and it can pick up this scope."
		},
		"continue": "Copy prompt & continue",
		"recheck": "Re-check",
		"rechecking": "Re-checking…",
		"connect": "Connect an agent",
		"viewProgress": "View progress",
		"dismiss": "Dismiss",
		"open": "Open",
		"prompt": "Use the KISS Scope tools on the \"{{title}}\" scope (id: {{scopeId}}) to {{action}}: {{url}}",
		"promptLabel": "Prompt",
		"copy": "Copy prompt",
		"copyAgain": "Copy prompt again",
		"checkBack": "Close, I'll check back",
		"back": "Back",
		"copied": "Copied",
		"copyFailed": "Couldn't copy the prompt"
	},
	"meta": {
		"scopes": {
			"title": "Scopes · KISS Scope",
			"description": "Scope: turn a rough idea into a documented plan and a ready-to-build backlog."
		},
		"archived": {
			"title": "Archived · KISS Scope",
			"description": "Scopes you have archived."
		},
		"stage": {
			"title": "{{stage}} · {{scope}} · KISS Scope"
		},
		"scopeDetail": {
			"title": "Scope"
		},
		"review": {
			"title": "Review"
		},
		"questions": {
			"title": "Questions"
		},
		"backlog": {
			"title": "Backlog"
		},
		"documents": {
			"title": "Documents",
			"docTitle": "{{doc}} · {{scope}} · KISS Scope"
		}
	},
	"a11y": {
		"close": "Close",
		"dismiss": "Dismiss",
		"imagePreview": "Image preview"
	},
	"field": {
		"moreInfo": "More information"
	}
}
